module.exports = __webpack_public_path__ + "img/NoResponseSmiley.d87f3229.svg";